import React from "react";
import style from "./index.module.scss";
import { NoWeekTimeCourse } from "API";
import { Badge, Icon } from "antd";
import SubmitError from "pages/main/components/SubmitError";
import { ResultMessage } from "components/ResultMessage";
import { useHistory } from "react-router-dom";
import { evaluationStatus } from "../../../../../API/evaluate";

interface IProps {
    className?: string;
    data: NoWeekTimeCourse;
    planCourse: boolean; // 非计划课程为false
    imgUrl: string;
}

function CourseItem({ className, data, planCourse, imgUrl }: IProps) {
    const history = useHistory();
    const {
        courseName,
        teacherName,
        lmsCourseNo,
        channelId,
        isOpen,
        courseNo,
        courseSeq,
        weekTimeId,
        batchNo
    } = data;

    const handleGoLive = (
        channelId: string,
        chapterId: string,
        lmsCourseNo: string
    ) => {
        if (!channelId) {
            ResultMessage.error(<SubmitError />, { width: 350 });
        } else {
            window.open(
                `/student/goToPlay?channelId=${channelId}&userId=${localStorage.getItem(
                    "user"
                )}&chapterCode=${chapterId}&versionCode=${lmsCourseNo}`
            );
        }
    };

    const courseInfoDom = planCourse ? (
        <>
            <img className={style.img} src={imgUrl} alt="" />
            <div className={style.title}>{courseName}</div>
        </>
    ) : (
        <>
            <img className={style.img} src={imgUrl} alt="" />
            <div className={`${style.title} ${!planCourse ? style.hover : ""}`}>
                {courseName}
            </div>
        </>
    );

    async function onEvaluateClick() {
        history.push(
            `/evaluate/${data?.evaluationId}/${data?.multiEvaluationFlag}`
        );
    }
    return (
        <div className={`${style.root} ${className}`}>
            <div className={style.main}>
                {courseInfoDom}
                <div className={style.info}>
                    <span>教师 {teacherName}</span>
                </div>

                <div className={style.footer}>
                    {data?.evaluationStatus &&
                        data.evaluationStatus !==
                            evaluationStatus.EvaluationIsNull && (
                            <div
                                className={style.btnRow}
                                onClick={onEvaluateClick}>
                                <div className={style.btnIcon}>
                                    <Badge
                                        dot
                                        count={
                                            data.evaluationStatus ===
                                            evaluationStatus.NotEvaluated
                                                ? 1
                                                : 0
                                        }>
                                        <Icon type="deployment-unit" />
                                    </Badge>
                                </div>
                                <div className={style.btnText}>评教</div>
                            </div>
                        )}
                    <div
                        className={style.btnRow}
                        onClick={() =>
                            history.push(
                                `/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/report`
                            )
                        }>
                        <div className={style.btnIcon}>
                            <Icon type="stock" />
                        </div>
                        <div className={style.btnText}>学习报告</div>
                    </div>
                    <div
                        className={style.btnRow}
                        onClick={() =>
                            history.push(
                                `/course/chapters/${courseNo}/${courseSeq}?courseName=${encodeURIComponent(
                                    courseName
                                )}`
                            )
                        }>
                        <div className={style.btnIcon}>
                            <Icon type="read" />
                        </div>
                        <div className={style.btnText}>查看章节</div>
                    </div>
                    {/*{planCourse && isOpen === "1" && (*/}
                    {/*    <div*/}
                    {/*        className={style.btnRow}*/}
                    {/*        onClick={() =>*/}
                    {/*            handleGoLive(channelId, "", lmsCourseNo)*/}
                    {/*        }>*/}
                    {/*        <div className={style.btnIcon}>*/}
                    {/*            <Icon type="desktop" />*/}
                    {/*        </div>*/}
                    {/*        <div className={style.btnText}>去上课</div>*/}
                    {/*    </div>*/}
                    {/*)}*/}
                    <div
                        className={style.btnRow}
                        onClick={() =>
                            history.push(
                                `/course/score/detail/${courseNo}/${courseSeq}/${weekTimeId}?courseName=${encodeURIComponent(
                                    courseName
                                )}`
                            )
                        }>
                        <div className={style.btnIcon}>
                            <img
                                className={style.scoreIcon}
                                src={require("./images/scoreIcon.png")}
                                alt=""
                            />
                            {/* <Icon type="calculator" /> */}
                        </div>
                        <div className={style.btnText}>成绩</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

CourseItem.defaultProps = {
    planCourse: true
};

export default CourseItem;
